import React from 'react'
import styled from 'styled-components'
import Icons from '../../Icons'
import MediaQuery from 'react-responsive'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const BuildingItem = ({onClick}) => {
  const localeState = useLocaleState()

  return (
    <MediaQuery maxWidth={420}>
      {matches => (
        <Container onClick={onClick} data-testid="building-item-container">
          <IconContainer>
            <Icons
              icon="BUILDING"
              width={matches ? 30 : 40}
              height={matches ? 30 : 40}
            />
            <Label>{_L({key: 'Buildings', localeState})}</Label>
          </IconContainer>
        </Container>
      )}
    </MediaQuery>
  )
}

export default BuildingItem

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  height: 78px;
  background-color: #282d41;
  padding: 4px;
  cursor: pointer;
`

const Label = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #5f6886;
  padding-top: 3px;

  @media (max-width: 420px) {
    font-size: 12px;
  }
`

const IconContainer = styled.div`
  min-width: 100px;
  min-height: 62px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 2px;

  @media (max-width: 420px) {
    min-width: 80px;
    min-height: 53px;
  }
`
